module.exports = __webpack_public_path__ + "img/collection-diamondJewelry070Carat@2x.8701d87.webp";